import React from 'react'
import styled from 'styled-components/macro'

import SidebarLayout from '../templates/SidebarLayout'
import Header from '../components/organisms/Header'
import { Text } from '../components/atoms/Typography'
import LoggedOutFooter from '../components/organisms/Footer/LoggedOutFooter'
import StoreLinks from '../components/atoms/StoreLinks'
import LoginForm from '../components/organisms/Forms/LoginForm'

export default function Login() {
  return (
    <SidebarLayout
      hideSidebar
      smallWrapper
      HeaderComp={
        <Header
          loggedOut
          title="Login"
          subtitle="Inserisci i tuoi dati per entrare nel mondo smart gym e iniziare ad allenarti."
        />
      }
      FooterComp={<LoggedOutFooter />}
    >
      <Article>
        <LoginForm />

        <Text>
          <p>
            Entra con le tue credenziali smartgym per gestire la tua palestra
            personale. <br />
            Dal sito web puoi: visualizzare le tue prenotazioni attive, le tue
            entrate rimanenti, acquistare nuove entrate e prenotare nuove
            sessioni.
          </p>
          <StoreLinks inline></StoreLinks>
        </Text>
      </Article>
    </SidebarLayout>
  )
}

const Article = styled.article`
  form {
    margin-bottom: 20px;
    a {
      display: block;
      color: #fe7e36;
      font-weight: 700;
      text-decoration: underline;
      margin-top: 5px;
    }
  }
  @media screen and (min-width: 1024px) {
    display: flex;
    form {
      width: 40%;
      max-width: 320px;
      margin-right: 90px;
      margin-bottom: 0;
    }
    section {
      flex: 1;
    }
  }
`
